import notificationApi from '@/api/notification.api'

const actions = {
  async loadNotificationByProject ({ rootState }, params) {
    const response = await notificationApi.getNotification(rootState.tenant.current, params.projectId, params.onlyThisProject)
    return response
  }
}


export default {
  actions
}
